import { apiRequest } from "./apiClient";

export const sendBroadcastNotification = ({ title, message, image }) => {
  const formData = new FormData();

  formData.append("title", title);
  formData.append("message", message);

  if (image) {
    formData.append("image", image);
  }

  return apiRequest("/notifications/broadcast", {
    method: "POST",
    body: formData,
  });
};

export const getBroadcastNotifications = () => {
  return apiRequest("/notifications/broadcasts");
};

export const getUserNotifications = () => {
  return apiRequest("/notifications");
};
